// extracted by mini-css-extract-plugin
export default {"consultants":"Consultants_consultants__NbYTB","consultants-title":"Consultants_consultants-title__8XoG-","consultants-list":"Consultants_consultants-list__sWD5b"};